import React from 'react';
import packageJson from '../../../package.json';
import { FooterWrapper, Divider, FooterTextContainer, FooterText, Version, Copyright, Column } from './Footer.styles';
import intertrustLogo from '../../../style/assets/intertrust-logo-white-90x16px.svg';

const currentDate = new Date();

export const Footer = () => (
    <FooterWrapper>
        <Divider />
        <FooterTextContainer>
            <FooterText>
                <Column>
                    <img alt="Intertrust Logo" src={intertrustLogo} />
                    <Version>v.{packageJson.version}</Version>
                </Column>
                <Copyright>© {currentDate.getFullYear()} Intertrust Technologies Corporation</Copyright>
            </FooterText>
        </FooterTextContainer>
    </FooterWrapper>
);

Footer.displayName = 'FooterComponent';
